import myAxios from "@/utils/request";
export default {
  getList(params) {
    return myAxios.post("/api/typicalcase/gettypicalpaging", params);
  },
  batchDelete(params) {
    return myAxios.post("/api/typicalcase/batchdelete", params);
  },

  // 添加需求详情
  addCase(params) {
    return myAxios.post("/api/typicalcase/add", params);
  },
  // 修改需求详情
  modifyCase(params) {
    return myAxios.post("/api/typicalcase/modify", params);
  },
  // 获取需求详细信息
  getCaseInfo(params) {
    const { id } = params;
    return myAxios.get("/api/typicalcase/getinfo?id=" + id);
  }
};
